module.exports = __webpack_public_path__ + "img/content7-3.2a04bcb4.webp";